<template>
  <div class="con-wrap">
    <div class="alarm-header">
      <div class="fl alarm-record">
        <span>发电告警(条):</span>
        <span class="red">{{ alarmCount.dynamoCount }}</span>
      </div>
      <div class="fl alarm-record">
        <span>车辆告警(条):</span>
        <span class="red">{{ alarmCount.vehicleCount }}</span>
      </div>
      <div class="fl alarm-record">
        <span>违规操作告警(条):</span>
        <span class="red">{{ alarmCount.violationCount }}</span>
      </div>
      <div class="fl alarm-record">
        <span>维保告警(条):</span>
        <span class="red">{{ alarmCount.maintenanceCount }}</span>
      </div>
      <div class="fl alarm-record">
        <span>工单告警(条):</span>
        <span class="red">{{ alarmCount.orderCount }}</span>
      </div>
    </div>
    <div class="alarm-con">
      <div class="query-box">
        <el-form ref="queryForm" :model="queryForm">
          <el-form-item class="query-form alarm-type" label="告警类型:">
            <el-checkbox-group v-model="queryForm.parentType" @change="typeChange">
              <el-checkbox v-for="item in alarmType" :key="item.code" :label="item.code">{{ item.value }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="query-form r-20" label="告警名称:">
            <el-select v-model="queryForm.type" placeholder="告警名称" no-data-text="请先选择告警类型" clearable>
              <el-option v-for="item in alarmNameList" :label="handleViolation(item)" :value="item.type"
                :key="item.type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="query-form r-20" label="车牌号:">
            <el-input v-model="queryForm.plate" placeholder="车牌号"></el-input>
          </el-form-item>
          <el-form-item class="query-form r-20" label="所属代维公司:">
            <el-select v-model="queryForm.companyId" placeholder="所属代维公司" clearable @change="companyChecked">
              <el-option v-for="item in devopsList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="query-form r-20" label="所属部门:">
            <el-cascader ref="cascader_ref" v-model="queryForm.deptIds" :options="deptList" :props="optionProps"
              clearable collapse-tags placeholder="所属部门"></el-cascader>
            <!-- <el-select
              v-model="queryForm.deptIds"
              clearable
              placeholder="所属部门"
            >
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.id"
                :value="item.id"
              ></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item class="query-form r-20" prop="time" label="告警开始时间:">
            <date-picker :startTime="queryForm.startTime" :endTime="queryForm.endTime" @changeStart="changeStart"
              @changeEnd="changeEnd">
            </date-picker>
          </el-form-item>
          <el-form-item class="query-form r-20">
            <el-button v-if="hasPerm('warn:remind:list')" type="primary" @click="query">查询</el-button>
            <el-button v-if="hasPerm('warn:remind:list')" @click="reset">取消</el-button>
          </el-form-item>
          <div style="margin-bottom: 20px">
            <el-button v-if="hasPerm('warn:remind:relieve')" type="primary" @click="alarmRelieve">告警解除</el-button>
            <el-button v-if="hasPerm('warn:remind:list')" type="primary" class="btn-width"
              @click="historyAlarm">历史告警查询</el-button>
            <el-button v-if="hasPerm('warn:remind:list')" type="primary" class="btn-width"
              @click="exportData">导出Excel</el-button>
          </div>
        </el-form>
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="mini" stripe
          height="560px" highlight-current-row @row-click="packageClickTableRow"
          @selection-change="packageSelectionChange">
          <el-table-column type="selection" width="24" align="center" style="padding: 0"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="55"></el-table-column>
          <el-table-column prop="warnType" label="告警类型" min-width="100"></el-table-column>

          <el-table-column prop="warnName" label="告警名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="startTime" label="告警开始时间" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="takeTime" label="告警历时（分钟）" show-overflow-tooltip min-width="112"></el-table-column>
          <el-table-column prop="vin" label="车架号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="plate" label="车牌号" show-overflow-tooltip>
            <template slot-scope="scope">
              <span @click.stop="gotoMonitor(scope.row.lnglat)" class="plate">{{
                scope.row.plate
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ownerName" label="车辆绑定人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="companyName" label="所属代维公司" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="deptName" label="所属部门" show-overflow-tooltip></el-table-column>
          <el-table-column prop="groupName" label="所属运维小组" show-overflow-tooltip min-width="90"></el-table-column>
          <el-table-column label="操作" width="160" prop="warnName">
            <template slot-scope="scope">
              <el-button size="mini" type="text" v-if="
                hasPerm('vehicle:details:status,vehicle:details:basic:info')
              " @click.stop="vehicleDetail(scope.row)">车辆详情</el-button>
              <el-button type="text" @click="toAlarmDetails(scope.row)">告警详情</el-button>
              <!-- <el-button
                size="mini"
                type="text"
                @click.stop="alarmDetail(scope.row)"
                v-if="
                  scope.row.warnName == '违规加油' &&
                    scope.row.warnBusId != '' &&
                    hasPerm('warn:remind:details:info')
                "
                >告警详情</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange"
          :current-page.sync="currentPage" :page-size="limit" layout="total, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </div>
    <!-- 告警解除 -->
    <el-dialog title="告警解除" :visible.sync="dialogRelieve" class="mini-dialog relieveDialog">
      <el-form ref="relieveForm" :model="relieveForm" :rules="rules" :inline="true">
        <el-form-item prop="relieveExplain" label="解除说明">
          <el-input type="textarea" v-model="relieveForm.relieveExplain"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRelieve = false">取 消</el-button>
        <el-button type="primary" @click="relieveAlarm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 违规加油告警详情 -->
    <el-dialog title="违规加油告警详情" :visible.sync="visible">
      <div id="open-map"></div>
      <div class="box">
        <p class="box-row">
          <span class="labels">起始点时间：</span>
          <span>{{ detailsCon.startTime }}</span>
        </p>
        <p class="box-row">
          <span class="labels">结束点时间：</span>
          <span>{{ detailsCon.endTime }}</span>
        </p>
        <p class="box-row">
          <span class="labels">起始点油量(升)：</span>
          <span>{{ detailsCon.startOil }}</span>
        </p>
        <p class="box-row">
          <span class="labels">结束点油量(升)：</span>
          <span class="vals">{{ detailsCon.endOil }}</span>
        </p>
        <p class="box-row">
          <span class="labels">本次加油量(升)：</span>
          <span>{{ detailsCon.endOil - detailsCon.startOil }}</span>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
import DatePicker from "@/components/DatePicker.vue";
export default {
  name: "AlarmMonitor",
  components: {
    DatePicker,
  },
  data() {
    return {
      queryForm: {
        parentType: [],
        type: "",
        plate: "",
        companyId: "",
        deptIds: [],
        startTime: "",
        endTime: "",
      },
      optionProps: {
        value: "id",
        multiple: true,
        emitPath: true,
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableData: [],
      alarmType: [],
      alarmCount: {},
      devopsList: [],
      deptList: [],
      alarmNameList: [],
      dialogRelieve: false,
      warnIds: [],
      relieveForm: { relieveExplain: "" },
      rules: {
        relieveExplain: [
          {
            required: false,
            trigger: "change",
            message: "请输入解除说明",
          },
        ],
      },
      refreshTime: null,
      // 告警详情
      visible: false,
      startMarker: "",
      endMarker: "",
      markers: [],
      content: [],
      startPosition: [],
      endPosition: [],
      geocoder: {},
      startInfoWindow: "",
      endInfoWindow: "",
      detailsCon: "",
      //防止每次数据改变重置定位地图
      opnMap: null,
      onceFlag: true,
      clickFlag: false,
    };
  },
  updated() {
    if (this.onceFlag) {
      this.opnMap = new AMap.Map("open-map", {
        // center: [116.397428, 39.90923],
        resizeEnable: true,
        zoom: 20,
      });
      AMap.plugin("AMap.Geocoder", () => {
        this.geocoder = new AMap.Geocoder({
          city: "全国", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        });
      });
    }
    if (this.clickFlag) {
      this.onceFlag = false;
    }
  },
  created() {
    if (this.$route.params.alarmCurPage) {
      this.queryForm = JSON.parse(sessionStorage.getItem("alarmQuery"));
      this.currentPage = parseInt(sessionStorage.getItem("alarmCurPage"));
    }
    if (this.$route.params.currentPage) {
      this.currentPage = parseInt(this.$route.params.currentPage);
    }
    if (this.$route.params.alarmPlateNum) {
      this.queryForm.plate = this.$route.params.alarmPlateNum;
    }
    let _this = this;
    //告警中心弹窗跳转时
    if (this.$route.query.parentType) {
      _this.queryForm.parentType.push(parseInt(_this.$route.query.parentType));
      _this.getAlarmList();
    } else {
      this.getAlarmList();
    }

    this.getAlarmCount();
    this.getAlarmType();
    this.getDevCompany();
    this.getDeptList();
  },
  mounted() {
    let _this = this;
    this.refreshTime = setInterval(function () {
      _this.getAlarmCount();
      _this.getAlarmList();
    }, 60000);
  },
  watch: {
    "queryForm.parentType"(val) {
      let _this = this;
      if (val) {
        this.$nextTick(() => {
          _this.getAlarmNameList();
        });
      }
    },
  },
  methods: {
    // 代维公司选中将id传递给部门列表接口，改变部门列表数据
    companyChecked(val) {
      this.queryForm.companyId = val;
      this.getDeptList();
    },
    async getDeptList() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        `/api/sys/dept/listDept?parentId=${this.queryForm.companyId}`
      );
      if (res.code == 1) {
        let data = _this.handleTreeData(res.data);
        _this.deptList = data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // el-cascader 控件 最后一级出现空白 暂无数据 页面
    handleTreeData(data) {
      data.forEach((item) => {
        if (item.children.length == 0) {
          item.children = undefined;
        } else {
          this.handleTreeData(item.children);
        }
      });
      return data;
    },
    changeStart(val) {
      this.queryForm.startTime = val;
    },
    changeEnd(val) {
      this.queryForm.endTime = val;
    },
    // ？？？ 新增跳转详情
    toAlarmDetails(row) {
      sessionStorage.setItem("pathUrl", "/AlarmMonitor");
      sessionStorage.setItem("alarmQuery", JSON.stringify(this.queryForm));
      sessionStorage.setItem("alarmCurPage", this.currentPage);
      // 跳转至告警详情页面
      this.$router.push({
        name: "AlarmDetails",
        params: {
          id: row.id,
          vin: row.vin,
          parentType: this.queryForm.parentType,
        },
      });
      // console.log(row);
      // 返回进来时的页面
      sessionStorage.setItem("alarmCurrentPage", this.currentPage);
    },
    // 处理后台返回数据项‘违规加油’的显示
    handleViolation(item) {
      if (item.type == 1202) {
        return "未熄火加油/未在加油站加油";
      } else {
        return item.name;
      }
    },
    // 跳转至运行监控
    gotoMonitor(lnglat) {
      sessionStorage.setItem("monitorLnglat", lnglat);
      sessionStorage.setItem("isSearch", false);
      const { href } = this.$router.resolve({
        path: "/fullScreenMonitor",
      });
      window.open(href, "_blank");
    },
    // 告警类型
    async getAlarmType() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/" + "warnRemind"
      );
      if (res.code == 1) {
        _this.alarmType = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 告警数量
    async getAlarmCount() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/warn/remind/count");
      if (res.code == 1) {
        _this.alarmCount = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //所属代维公司
    async getDevCompany() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/warn/remind/company");
      if (res.code == 1) {
        _this.devopsList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //获取告警名称列表
    async getAlarmNameList() {
      let _this = this;
      let obj = {
        parentType: _this.queryForm.parentType.toString(),
      };
      let { data: res } = await _this.$axios.get("/api/warn/remind/type", {
        params: obj,
      });
      if (res.code == 1) {
        _this.alarmNameList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //数据导出
    exportData() {
      let _this = this;
      _this
        .$confirm("确定导出当前查询数据吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        })
        .then(async () => {
          let obj = {};
          let url = "";
          obj.parentType = _this.queryForm.parentType.toString();
          obj.type = _this.queryForm.type;
          obj.plate = _this.queryForm.plate;
          obj.companyId = _this.queryForm.companyId;
          url =
            "/api/warn/remind/export?parentType=" +
            obj.parentType +
            "&type=" +
            obj.type +
            "&companyId=" +
            obj.companyId +
            "&plate=" +
            obj.plate +
            "&warnStatus=1";
          window.location.href = url;
        });
    },
    //获取告警列表数据
    async getAlarmList() {
      let _this = this;
      let obj = {};
      obj.parentType = _this.queryForm.parentType.toString();
      obj.type = _this.queryForm.type;
      obj.plate = _this.queryForm.plate;
      obj.companyId = _this.queryForm.companyId;
      obj.deptIds = _this.queryForm.deptIds.join(",");
      obj.warnStartTime = _this.queryForm.startTime;
      obj.warnEndTime = _this.queryForm.endTime;
      obj.warnStatus = 1;
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      let { data: res } = await _this.$axios.get("/api/warn/remind/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    query() {
      this.getAlarmList();
      this.getAlarmCount();
    },
    reset() {
      this.queryForm.parentType = [];
      this.queryForm.type = "";
      this.queryForm.plate = "";
      this.queryForm.companyId = "";
      this.queryForm.deptIds = [];
      this.queryForm.startTime = "";
      this.queryForm.endTime = "";
      this.getAlarmList();
      this.getAlarmCount();
    },
    alarmRelieve() {
      this.warnIds = this.$getIds(this.$refs.multipleTable.selection);
      if (!this.warnIds) {
        return;
      }
      let type = this.$refs.multipleTable.selection[0].warnType;
      if (type == "违规操作告警" || type == "维保告警") {
        this.$resetForm(this, "relieveForm");
        this.relieveForm.relieveExplain = "";
        this.dialogRelieve = true;
      } else {
        this.$message.warning(type + "无法手动解除");
      }
    },
    historyAlarm() {
      this.$router.push({
        name: "HistoryAlarm",
        params: {},
      });
    },
    // 解除告警
    relieveAlarm() {
      let _this = this;
      _this.$refs.relieveForm.validate(async (valid) => {
        if (valid) {
          let obj = {
            relieveMsg: this.relieveForm.relieveExplain,
            warnIds: this.warnIds,
          };
          let { data: res } = await _this.$axios.patch(
            "/api/warn/remind/relieve",
            obj
          );
          if (res.code == 1) {
            _this.dialogRelieve = false;
            _this.getAlarmList();
            _this.getAlarmCount();
            _this.$message.success("解除成功");
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
    vehicleDetail(rowData) {
      sessionStorage.setItem("pathUrl", "/AlarmMonitor");
      sessionStorage.setItem("alarmQuery", JSON.stringify(this.queryForm));
      sessionStorage.setItem("alarmCurPage", this.currentPage);
      this.$router.push({
        name: "VehicleInfo",
        params: {
          vin: rowData.vin,
          active: "real",
        },
      });
    },
    //告警详情
    alarmDetail(rowData) {
      //设置弹框标题
      this.warnBusId = rowData.warnBusId;
      this.getAlarmData();
    },
    //违规加油告警详情--start
    async getAlarmData() {
      let _this = this;
      let obj = {
        warnBusId: _this.warnBusId,
      };
      let { data: res } = await _this.$axios.get(
        "/api/warn/remind/details/info",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        if (res.data) {
          _this.detailsCon = res.data.data;
          _this.location(res.data.data);
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查询加油前后定位
    location(data) {
      let _this = this;
      this.visible = true;
      this.clickFlag = true;
      _this.startPosition = [data.startLongitude, data.startLatitude];
      _this.endPosition = [data.endLongitude, data.endLatitude];
      //清理覆盖物
      if (_this.startMarker || _this.endMarker) {
        _this.opnMap.remove(_this.startMarker);
        _this.opnMap.remove(_this.endMarker);
      }
      _this.startMarker = new AMap.Marker({
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: _this.startPosition,
      });
      _this.endMarker = new AMap.Marker({
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
        position: _this.endPosition,
      });
      _this.getAddr(_this.startPosition, "1");
      _this.getAddr(_this.endPosition, "2");
      _this.$nextTick(() => {
        // 更改地图中心点
        _this.opnMap.setCenter(_this.startPosition);
        _this.opnMap.add([_this.startMarker, _this.endMarker]);

        AMap.event.addListener(_this.startMarker, "click", function () {
          _this.opnMap.clearInfoWindow();
          _this.startInfoWindow.open(
            _this.opnMap,
            _this.startMarker.getPosition()
          );
        });
        AMap.event.addListener(_this.endMarker, "click", function () {
          _this.opnMap.clearInfoWindow();
          _this.endInfoWindow.open(_this.opnMap, _this.endMarker.getPosition());
        });
      });
    },
    getAddr(position, flag) {
      // 确保 geocoder 已初始化
      if (!this.geocoder) {
        console.error("Geocoder 未初始化，请检查插件加载");
        return;
      }
      let _this = this;
      _this.geocoder.getAddress(position, function (status, result) {
        if (status === "complete" && result.regeocode) {
          _this.content = [];
          if (flag === "2") {
            _this.content.push(
              "<p><span style='margin-right:6px'>结束点位置: </span>" +
              result.regeocode.formattedAddress +
              "</p>"
            );
            _this.endInfoWindow = new AMap.InfoWindow({
              isCustom: true,
              content: _this.createInfoWindow(_this.content),
              offset: new AMap.Pixel(16, -45),
            });
          } else {
            _this.content.push(
              "<p><span style='margin-right:6px'>起始点位置: </span>" +
              result.regeocode.formattedAddress +
              "</p>"
            );
            _this.startInfoWindow = new AMap.InfoWindow({
              isCustom: true,
              content: _this.createInfoWindow(_this.content),
              offset: new AMap.Pixel(16, -45),
            });
          }
          //   _this.information.address = result.regeocode.formattedAddress
        } else {
          _this.$message.warning("根据经纬度查询地址失败");
        }
      });
    },
    createInfoWindow() {
      let _this = this;
      var info = document.createElement("div");
      info.style.background = "#fff";
      info.style.height = "80px";
      info.style.border = "1px solid #ccc";
      info.style.borderRadius = "4px";
      //顶部内容
      var top = document.createElement("div");
      top.style.height = "26px";
      top.style.position = "relative";
      info.className = "realtimeLocation";
      var closeX = document.createElement("img");
      closeX.style.position = "absolute";
      closeX.style.top = "10px";
      closeX.style.right = "10px";
      closeX.style.cursor = "pointer";
      closeX.src = "https://webapi.amap.com/images/close2.gif";
      closeX.addEventListener("click", () => {
        _this.opnMap.clearInfoWindow();
      });
      top.appendChild(closeX);
      info.appendChild(top);
      // 定义中部内容
      var middle = document.createElement("div");
      middle.style.backgroundColor = "white";
      middle.style.padding = "0 20px";
      middle.style.color = "#333";
      middle.innerHTML = this.content;
      info.appendChild(middle);
      //底部内容
      var bottom = document.createElement("div");
      bottom.style.position = "relative";
      bottom.style.width = "30px";
      bottom.style.top = "16px";
      bottom.style.left = "146px";
      var sharp = document.createElement("img");
      sharp.src = "https://webapi.amap.com/images/sharp.png";
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },
    //违规加油告警详情--end
    //数据列表选择
    packageSelectionChange(val) {
      //实现单选
      if (val.length > 1) {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleRowSelection(val.pop());
      }
      this.packageVal = val;
    },
    packageClickTableRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAlarmList();
    },
    typeChange(val) {
      this.queryForm.parentType = val;
      this.queryForm.type = "";
    },
  },
  beforeDestroy() {
    let _this = this;
    //页面关闭时清除定时器
    clearInterval(_this.refreshTime);
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  height: calc(100% - 40px);
  overflow: auto;
  font-size: 14px;
  color: #333;

  // 隐藏全选框
  /deep/ .el-table__header-wrapper .el-table-column--selection .cell {
    display: none;
  }
}

.fl {
  float: left;
}

//头部
.alarm-header {
  width: 100%;
  height: 48px;
  padding: 0 20px;
  background-color: #fff;
  font-size: 14px;
  box-sizing: border-box;

  .alarm-record {
    margin-right: 40px;
    line-height: 48px;
  }

  .red {
    padding-left: 10px;
    color: #f6392a;
    font-size: 16px;
  }
}

//内容
.alarm-con /deep/ {
  width: 100%;
  height: calc(100% - 58px);
  margin-top: 10px;
  padding: 20px;
  background-color: #fff;
  box-sizing: border-box;
  overflow: auto;

  .query-form {
    display: inline-block;

    .el-select {
      width: 260px;
    }

    .el-input {
      width: 260px;
    }

    .el-form-item__label,
    .el-form-item__content {
      float: left;
    }

    .time>.el-col-1 {
      margin-left: 30px !important;
      text-align: center;
    }
  }

  .alarm-type {
    display: block !important;

    .el-checkbox-group {
      height: 22px;
    }

    .el-form-item__label,
    .el-form-item__content {
      line-height: 22px !important;
      float: left;
    }
  }
}

.btn-width {
  width: 108px;
}

.relieveDialog /deep/ {
  .el-form-item__content {
    height: auto !important;
  }

  .el-form-item__error {
    top: 72px !important;
  }
}

.plate {
  color: #0094ff;
  cursor: pointer;
}

#open-map {
  width: 100%;
  height: 580px;
}

.box {
  height: 160px;
  line-height: 28px;
  border-radius: 6px;
  padding: 10px 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  position: absolute;
  top: 60px;
  left: 20px;

  .box-row {
    .labels {
      display: inline-block;
      text-align: right;
      width: 110px;
    }
  }
}

::v-deep .el-cascader {
  input {
    height: 32px !important;
  }

  .el-cascader__tags {
    width: 64%;
    flex-wrap: nowrap;
  }
}
</style>
